<div class="header"
     (appClickOutside)="showSearch=false;"
     [class.disabled]="!userDetails || !userDetails?.hasConciergeRights">
     <!-- || !isActiveView -->
  <!--  @todo: breadcrumbs -->
  <div class="header__search-wrapper" *ngIf="showSearch">
    <app-global-search></app-global-search>
  </div>
  <div class="header__actions">
    <div class="header__actions__icons">
      <!--      @todo: replace by icons-->
      <div class="global-search-wrapper" [class.active]="showSearch">
        <i
          class="search-icon"
          [class.icon-search-input-default-24]="!showSearch"
          [class.icon-close-search-24]="showSearch"
          (click)="showSearch = !showSearch"
        ></i>
      </div>
      <!-- Phase 1 - User notification calls are commented. Hence, hiding the notification icon in the header. -->
      <!-- <div class="notification"
           [class.shown]="notificationTooltip.opened"
           [appTooltip]="userNotification"
           [tooltipInvokeType]="'click'"
           [tooltipHasBeak]="false"
           [tooltipPosition]="'bottomRight'"
           [tooltipCustomClass]="'user-notification'"
           #notificationTooltip="app-tooltip">
        <div class="count" *ngIf="(notifications$ | async).length">
          <span>{{(notifications$ | async).length}}</span>
        </div>
        <i class="icon-notification-bell-outline-24"></i>
      </div> -->
      <div class="staticlinks-icon" [class.shown]="staticLinkTooltip.opened">
        <i
          class="icon-tiles-waitlist-default-24"
          [appTooltip]="staticURLs"
          [tooltipInvokeType]="'click'"
          [tooltipHasBeak]="false"
          [tooltipPosition]="'bottomRight'"
          [tooltipCustomClass]="'header--tooltip'"
          #staticLinkTooltip="app-tooltip"
        ></i>
      </div>
    </div>
    <div class="header__actions__dropdown ml-4">
      <app-view-selector></app-view-selector>
    </div>
  </div>
</div>
<ng-template #userNotification>
  <div class="user-notification-wrapper">
    <div class="notification-title">
      {{'Translation.Notification' | translate}}
    </div>
    <div class="notification-list">
      <app-user-notification
        *ngFor="let item of notifications$ | async"
        [notification]="item"
        (remove)="removeNotification($event)"
      ></app-user-notification>
    </div>
  </div>
</ng-template>
<ng-template #staticURLs>
  <app-staticlink-navigation></app-staticlink-navigation>
</ng-template>
